module.exports = __webpack_public_path__ + "static/media/logo_white.90c6b16d.svg";